<gl-base-modal (closeModal)="close(false)">
  <p>{{ 'about_my_account_message' | translate }}</p>
  <div class="buttons center">
    <button outline-button (click)="close(true)">{{ 'complete' | translate }}</button>
  </div>
</gl-base-modal>
